<template>
  <div>
    <div v-if="activityData.messageDate == todayDate">
      <div class="timeline" v-if="activityData.messageDate !== '' && defaultView">
        <p> <span class="bubble success"></span>Today</p>
      </div>
    </div>
    <div v-else>
      <div class="timeline" v-if="activityData.messageDate !== '' && defaultView">
        <p> <span class="bubble"></span>{{ formatDate(activityData.ts)  }}</p>
      </div>
    </div>
    <!-- ENTRY (MESSAGE)-->
    <div class="entry" v-if="activityData.type === 'message'">
      <div class="grid-x align-middle">
        <div class="cell small-2 medium-shrink activity-type"><img src="../../../assets/images/icons/icon-activity-message.svg" alt="message"></div>
        <div class="cell small-12 medium-auto">
          <h6 v-if="activityData.direction === 'in'" > <img src="../../../assets/images/icons/icon-arrow-in.svg"  alt="inbound">Message Received <span v-if="$route.name == 'dashboard.dashboard'" class="time">{{ formatTime(activityData.ts) }}</span></h6>
          <h6 v-if="activityData.direction === 'out'" > <img src="../../../assets/images/icons/icon-arrow-out.svg"  alt="outbound">Message Sent <span v-if="$route.name == 'dashboard.dashboard'" class="time">{{ formatTime(activityData.ts) }}</span></h6>
          <p>{{activityData.message}}</p>
          <span>to {{getName(activityData.to)}} from {{getName(activityData.from)}} </span>
          <!-- <div class="labels" v-if="$route.name == 'dashboard.dashboard'&& activityData.direction === 'out'">
            <span class="label secondary">SMS Forwarding</span
            ><span class="label secondary">SMS to Email</span
            ><span class="label secondary">Auto Response</span>
          </div> -->
          <span v-if="(activityData.connected === null || activityData.connected === '0') && $route.name !== 'dashboard.dashboard'" class="detail">&bull; {{ formatDate(activityData.ts) }} {{ formatTime(activityData.ts) }}  </span>
          <span  v-if="activityData.connected === '1' && (  activityData.duration !== null || activityData.duration !== '0' && $route.name !== 'dashboard.dashboard') " class="detail">&bull; {{ duration(activityData.ts, 'humanize')  }} {{ formatDate(activityData.ts) }} {{ formatTime(activityData.ts) }} </span>
        </div>
        <div v-if="$route.name !== 'dashboard.dashboard'" class="cell hide-for-small-only shrink">
          <div class="credits"><img src="../../../assets/images/icons/coin-s.svg" alt="bt coin">
          <span v-if="activityData.creditinout === 'out' && activityData.credit !== '0' " class="negative">{{ creditFilter(activityData.credit)  }}</span>
          <span v-else>{{ creditFilter(activityData.credit)  }}</span>
          </div>
        </div>
        <activity-tootip @onDelete="tooltipAction" :tooltipType="'lastActivityMessage'" :tooltipData="activityData" v-if="(dataNumber+1 == datatotalnumber && datatotalnumber > 2 ) && $route.name !== 'dashboard.dashboard'" > </activity-tootip>
        <activity-tootip @onDelete="tooltipAction" :tooltipType="'activityMessage'" :tooltipData="activityData" v-if="(dataNumber+1 != datatotalnumber || datatotalnumber < 3 ) && $route.name !== 'dashboard.dashboard'" > </activity-tootip>
      </div>
    </div>
    <!-- ENTRY (CALL) -->
    <div class="entry" v-if="activityData.type === 'call'">
      <div class="grid-x align-middle">
        <div class="cell small-2 medium-shrink activity-type"><img src="../../../assets/images/icons/icon-activity-call.svg" alt="call"></div>
        <div class="cell small-12 medium-auto">
          <h6 v-if="activityData.direction === 'out'" > <img src="../../../assets/images/icons/icon-arrow-out.svg" alt="outbound">Voice Call<span v-if="$route.name == 'dashboard.dashboard'" class="time">{{ formatTime(activityData.ts) }}</span></h6>
          <h6 v-if="activityData.direction === 'in'" > <img src="../../../assets/images/icons/icon-arrow-in.svg" alt="inbound">Voice Call<span v-if="$route.name == 'dashboard.dashboard'" class="time">{{ formatTime(activityData.ts) }}</span></h6>
          <p class="open-audio" v-if="activityData.recordurl != null && activityData.direction === 'out'
             && (activityData.duration !== null && activityData.duration !== '0')">
            <img src="../../../assets/images/icons/icon-activity-recording-available.svg" alt="recording available">
            Recording Available
          </p>
          <div class="audio-content" v-if="activityData.recordurl != null && activityData.direction === 'out'
            && (activityData.duration !== null && activityData.duration !== '0')">
            <div class="sound-container">
              <div class="audiopiece-container">
                <audio class="mejs__player" :id="'player'+activityData.id" preload="none" controls="" style="max-width:100%;">
                  <source :src="activityData.recordurl" type="audio/mp3">
                </audio>
              </div>
            </div>
          </div>
          <span>to {{ getName(activityData.to)}} from {{getName(activityData.from)}} </span>
          <!-- <span>to {{activityData.to}} from {{activityData.from}} </span> -->
          <!-- <div class="labels" v-if="$route.name == 'dashboard.dashboard' && activityData.direction === 'out'">
            <span class="label secondary">Voice Mailbox</span
            ><span class="label secondary">Call Forwarding</span
            ><span class="label secondary">Text to Speech</span>
          </div> -->
          <span v-if="(activityData.connected === null || activityData.connected === '0') && $route.name !== 'dashboard.dashboard'" class="detail">&bull; {{ 'Call did\'t sent' }} {{ formatDate(activityData.ts) }}  {{ formatTime(activityData.ts) }}  </span>
          <span v-if="activityData.connected === '1' && (  activityData.duration !== null || activityData.duration !== '0' && $route.name !== 'dashboard.dashboard')" class="detail">&bull;
            <span v-if="activityData.lastconnected === null || activityData.lastconnected === '0' ">{{ 'call did\'t connected' }} </span>
            <span v-if="activityData.duration != null && activityData.duration != '0'">{{ activityData.duration + " seconds" }} </span>
            {{ formatDate(activityData.ts) }} {{ formatTime(activityData.ts) }} </span>
        </div>
        <div v-if="$route.name !== 'dashboard.dashboard'" class="cell hide-for-small-only shrink">
          <div class="credits"><img src="../../../assets/images/icons/coin-s.svg" alt="bt coin">
            <span v-if="activityData.creditinout === 'out' && activityData.credit !== '0' " class="negative">{{ creditFilter(activityData.credit)  }}</span>
            <span v-else>{{ creditFilter(activityData.credit)  }}</span>
          </div>
        </div>
        <activity-tootip @onDelete="tooltipAction" :tooltipType="'lastActivityCall'" :tooltipData="activityData" v-if="(dataNumber+1 == datatotalnumber && datatotalnumber > 2 ) && $route.name !== 'dashboard.dashboard'"> </activity-tootip>
        <activity-tootip @onDelete="tooltipAction" :tooltipType="'activityCall'" :tooltipData="activityData" v-if="(dataNumber+1 != datatotalnumber || datatotalnumber < 3) && $route.name !== 'dashboard.dashboard'"> </activity-tootip>
      </div>
    </div>
    <!-- ENTRY(FAX) -->
    <div class="entry" v-if="activityData.type === 'fax'">
      <div class="grid-x align-middle" >
        <div class="cell small-2 medium-shrink activity-type"><img src="../../../assets/images/icons/icon-activity-call.svg" alt="fax"></div>
        <div class="cell small-12 medium-auto">
          <h6> <img src="../../../assets/images/icons/icon-arrow-out.svg" alt="outbound">FAX Sent <span v-if="$route.name == 'dashboard.dashboard'" class="time">{{ formatTime(activityData.ts) }}</span></h6>
          <p><a :href="'https://www.blacktel.io/'+activityData.fax" target="_blank">
              <svg width="14" height="12" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2">
                <path d="M12.941 5.389h-.001a.56.56 0 00-.559.559v3.906a.68.68 0 01-.679.679H1.798a.68.68 0 01-.679-.679V5.948a.559.559 0 10-1.119 0v3.907c0 .992.805 1.797 1.798 1.797h9.904c.993 0 1.798-.805 1.798-1.797V5.948a.56.56 0 00-.559-.559zM6.617 9.417h.09c.025-.002.06-.009.06-.009s-.034.006-.051.006a.243.243 0 00.039-.005.349.349 0 00.037-.007.245.245 0 00.064-.018l.055-.024a.354.354 0 00.033-.019l.004-.003A.233.233 0 007 9.304l1.993-1.708a.56.56 0 00-.728-.85l-1.048.897V.56a.56.56 0 10-1.119 0v7.083l-1.049-.897a.56.56 0 10-.727.85L6.29 9.283l-.002-.001.021.018a.27.27 0 00.09.055l.06.029c.02.009.041.015.063.018a.325.325 0 00.038.007.416.416 0 01-.013-.001s.047.009.07.009zm.165-.013h-.006l-.032.004.022-.002.016-.002zm-.249 0l.015.002a.199.199 0 00.022.002l-.032-.004h-.005zm-.095-.032l.01.006.007.003-.017-.009zm.461-.008l-.008.004.005-.002.003-.002z" fill="#768db3" fill-rule="nonzero"></path>
              </svg>View Document as PDF</a></p><span>to {{getName(activityData.to)}} from {{getName(activityData.from)}} </span>
              <div class="labels" v-if="$route.name == 'dashboard.dashboard' && activityData.direction === 'out'">
                  <!-- <span class="label secondary">FAX Forwarding</span
                  ><span class="label secondary">Fax sent to email</span> -->
              </div>
              <span v-if="$route.name !== 'dashboard.dashboard'" class="detail">&bull; {{formatDate(activityData.ts)}} {{formatTime(activityData.ts) }} </span>
        </div>
        <div v-if="$route.name !== 'dashboard.dashboard'" class="cell hide-for-small-only shrink">
          <div class="credits"><img src="../../../assets/images/icons/coin-s.svg" alt="bt coin">
          <span v-if="activityData.creditinout === 'out' && activityData.credit !== '0' " class="negative">{{creditFilter(activityData.credit)}}</span>
          <span v-else>{{creditFilter(activityData.credit)}}</span>
          </div>
        </div>
        <activity-tootip @onDelete="tooltipAction" :tooltipType="'lastActivityFax'" :tooltipData="activityData" v-if="(dataNumber+1 == datatotalnumber && datatotalnumber > 2 ) && $route.name !== 'dashboard.dashboard'"> </activity-tootip>
        <activity-tootip @onDelete="tooltipAction" :tooltipType="'activityFax'" :tooltipData="activityData" v-if="(dataNumber+1 != datatotalnumber || datatotalnumber < 3 ) && $route.name !== 'dashboard.dashboard'"> </activity-tootip>
      </div>
    </div>
      <!-- ENTRY (NUMBER ADDED)-->
    <div class="entry" v-if="activityData.type === 'number'">
      <div class="grid-x align-middle">
        <div class="cell small-2 medium-shrink activity-type"><img src="../../../assets/images/icons/icon-activity-info.svg" alt="information"></div>
        <div class="cell small-12 medium-auto">
          <h6>{{activityData.title}} <span v-if="$route.name == 'dashboard.dashboard'" class="time">{{formatTime(activityData.ts)}}</span></h6>
          <p v-html="activityData.info"></p>
          <span v-if="$route.name !== 'dashboard.dashboard'" class="detail">&bull; {{formatDate(activityData.ts)}} {{formatTime(activityData.ts)}} </span>
        </div>
        <div v-if="$route.name !== 'dashboard.dashboard'" class="cell hide-for-small-only shrink">
          <div class="credits"><img src="../../../assets/images/icons/coin-s.svg" alt="bt coin">
            <span v-if="activityData.creditinout === 'out' && activityData.credit !== '0' " class="negative">{{creditFilter(activityData.credit)}}</span>
            <span v-else>{{creditFilter(activityData.credit)}}</span>
          </div>
        </div>
        <activity-tootip @onDelete="tooltipAction" :tooltipType="'lastNumber'" :tooltipData="activityData.id" v-if="(dataNumber+1 == datatotalnumber && datatotalnumber > 2 ) && $route.name !== 'dashboard.dashboard'"> </activity-tootip>
        <activity-tootip @onDelete="tooltipAction" :tooltipType="'number'" :tooltipData="activityData.id" v-if="(dataNumber+1 != datatotalnumber || datatotalnumber < 3 ) && $route.name !== 'dashboard.dashboard'"> </activity-tootip>
      </div>
    </div>
    <!-- ENTRY (CREDITS ADDED)-->
    <div class="entry" v-if="activityData.type === 'info' || activityData.type ===  'transaction'">
      <div class="grid-x align-middle">
        <div class="cell small-2 medium-shrink activity-type"><img src="../../../assets/images/icons/icon-activity-info.svg" alt="transaction"></div>
        <div class="cell small-12 medium-auto">
          <h6>{{activityData.title}}<span v-if="$route.name == 'dashboard.dashboard'" class="time">{{formatTime(activityData.ts)}}</span></h6>
          <p v-html="activityData.info"></p>
          <span v-if="$route.name !== 'dashboard.dashboard'" class="detail">&bull; {{formatDate(activityData.ts)}} {{formatTime(activityData.ts)}}  </span>
        </div>
        <div v-if="$route.name !== 'dashboard.dashboard'" class="cell hide-for-small-only shrink">
          <div v-if="activityData.type === 'info'" class="credits"><img src="../../../assets/images/icons/coin-s.svg" alt="bt coin">
          <span v-if="activityData.creditinout === 'free'">{{ creditFilter(activityData.credit)  }}</span>
            <span v-else class="negative">{{ creditFilter(activityData.credit)  }}</span>
          </div>
          <div v-if="activityData.type ===  'transaction'" class="credits"><img src="../../../assets/images/icons/coin-s.svg" alt="bt coin">
          <span >+ {{ creditFilter(activityData.credit)  }}</span>
          </div>
        </div>
        <activity-tootip @onDelete="tooltipAction" :tooltipType="'lastNotification'" :tooltipData="activityData.id" v-if="(dataNumber+1 == datatotalnumber && datatotalnumber > 2 ) && $route.name !== 'dashboard.dashboard'"> </activity-tootip>
        <activity-tootip @onDelete="tooltipAction" :tooltipType="'notification'" :tooltipData="activityData.id" v-if="(dataNumber+1 != datatotalnumber || datatotalnumber < 3 ) && $route.name !== 'dashboard.dashboard'"> </activity-tootip>
      </div>
    </div>
    <!-- ENTRY (ERROR)-->
    <div class="entry" v-if="activityData.type === 'error'">
      <div class="grid-x align-middle">
        <div class="cell small-2 medium-shrink activity-type"><img src="../../../assets/images/icons/icon-activity-error.svg" alt="error information"></div>
        <div class="cell small-12 medium-auto">
          <h6>{{activityData.title}}<span v-if="$route.name == 'dashboard.dashboard'" class="time">{{ formatTime(activityData.ts) }}</span></h6>
          <p v-html="activityData.info"></p><span></span>
          <span v-if="$route.name !== 'dashboard.dashboard'" class="detail">&bull; {{formatDate(activityData.ts)}} {{ formatTime(activityData.ts)}} </span>
        </div>
        <div class="cell hide-for-small-only shrink"> </div>
        <activity-tootip @onDelete="tooltipAction" :tooltipType="'lastError'" :tooltipData="activityData.id" v-if="(dataNumber+1 == datatotalnumber && datatotalnumber > 2) && $route.name !== 'dashboard.dashboard'"> </activity-tootip>
        <activity-tootip @onDelete="tooltipAction" :tooltipType="'error'" :tooltipData="activityData.id" v-if="(dataNumber+1 != datatotalnumber || datatotalnumber < 3 ) && $route.name !== 'dashboard.dashboard'"> </activity-tootip>
      </div>
    </div>
  </div>
</template>
<script>
import { blacktel } from "../../../config/pluginInit"
import { creditFilter, formatDate, formatTime, duration } from '@/utilities/filter'
import deleteInputConfirm from '../modal/delete-input-confirm.vue'
export default {
  // eslint-disable-next-line vue/no-unused-components
  components: { deleteInputConfirm },
    name:'activity-card',
    props:{
        activityData:{},
        dataNumber: {default: ''},
        datatotalnumber: {default: ''},
        defaultView:{
          type:Boolean,
          default: false
        }
    },
    data :() => ({
      todayDate : new Date().getDate()+' '+new Date().toLocaleString('default', { month: 'long' })+ ', '+new Date().getFullYear()
    }),
    // mounted(){
    //     blacktel.audioInit()
    //     blacktel.openAudio()
    // },
    methods: {
      creditFilter,
      formatDate,
      formatTime,
      duration,
      tooltipAction: function (DeleteData) {
        this.$emit('ontooltipDelete', DeleteData);
      },
      getName (number) {
      // get name from address book contact
        let result = blacktel.searchAddressBookName(number)
        let result1 = blacktel.searchvirtualNumbersName(number)
        if(result != number){
          return result
        }else if(result1 != number){
          return result1
        }else {
          return "+"+number
        }
        // return (result === '' ? number : result)

      },
    },
  }
</script>
